<template>
  <v-row>
    <v-col cols="12">
      <v-card class="card" :elevation="elevation">
        <v-card-title class="card-title" v-if="filter || searchString">
          <template v-if="filter">
            <v-text-field
              v-model="searchItem"
              append-icon="mdi-magnify"
              label="Поиск"
              clearable dense outlined rounded hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <slot name="button"></slot>
          </template>

          <template v-if="searchString">
            <slot name="searchString"></slot>
          </template>
        </v-card-title>

        <v-data-table
          ref="table"
          class="table"
          :search="searchItem"
          :loading="tableLoading"
          :headers="tableHeaders"
          :items="tableItems"
          v-model="localValue"
          :single-select="singleSelect"
          :show-select="showSelect"
          :single-expand="singleExpand"
          :show-expand="showExpand"
          :height="height"
          loading-text="Загрузка"
          hide-default-footer
          fixed-header
          :custom-sort="customSort"
          :items-per-page="-1"
          v-scroll.self="tableScroll"
          @change="event => $emit('change', event)"
          @input="event => $emit('input', event)"
          @item-expanded="showItemExpanded"
          @click:row="select"
        >
          <template
            v-for="slotName in Object.keys($scopedSlots)"
            v-slot:[slotName]="slotScope"
          >
            <slot :name="slotName" v-bind="slotScope"></slot>
          </template>

          <template slot="no-data">
            <div>Таблица пуста</div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import {cloneDeep} from "lodash";

export default {
  name: 'Table',

  props: {
    searchString: Boolean,

    value: Array,
    showSelect: {
      type: Boolean,
      default: false
    },
    singleSelect: {
      type: Boolean,
      default: false
    },
    singleExpand: {
      type: Boolean,
      default: false
    },
    showExpand: {
      type: Boolean,
      default: false
    },
    tableLoading: Boolean,
    tableHeaders: {
      type: Array,
      default: () => []
    },
    tableItems: {
      type: Array,
      default: () => []
    },
    tableHeight: {
      type: [String, Number],
      default: () => 275
    },
    filter: {
      type: Boolean,
      default: false
    },
    customSort: Function,

    elevation: {
      type: [String, Number],
      default: ''
    },
    height: {
      type: Number,
      default: 0
    }
  },

  async created() {
    this.hideHtmlOverflow()
    this.localValue = this.value
  },

  mounted() {
    this.setTableHeight()
    window.addEventListener("resize", this.setTableHeight)
  },

  destroyed() {
    window.removeEventListener("resize", this.setTableHeight)
    this.showHtmlOverflow()
  },

  data: () => ({
    searchItem: '',
    localValue: []
  }),

  computed: {
    ...mapGetters('system', ['techMessageHeight']),
  },

  methods: {
    setTableHeight() {
      if (!this.height) {
        // суммарная высота элементов на странице, кроме таблицы
        // const otherElements = +this.tableHeight + this.techMessageHeight
        // if (this.$refs?.table) {
        //   this.$refs.table.$el.style.maxHeight = window.innerHeight - otherElements + 'px'
        // }

        this.$nextTick(() => {
          if (this.$refs?.table) {
            const footerHeight = 120
            const topHeight = this.$refs.table.$el.getBoundingClientRect().top

            this.$refs.table.$el.style.height = window.innerHeight - topHeight - footerHeight + 'px'
          }
        })
      }
    },

    tableScroll(event) {
      const el = event.target
      if (el.scrollHeight - el.clientHeight - el.scrollTop <= 10 && !this.tableLoading) {
        this.$emit('get-data')
      }
    },

    showItemExpanded(item) {
      this.$emit('showItemExpanded', item)
    },

    select(item) {
      this.$emit('select', item)
    },

    hideHtmlOverflow() {
      document.querySelector('html').style.overflowY = 'hidden'
    },

    showHtmlOverflow() {
      document.querySelector('html').style.overflowY = 'visible'
    }
  },

  watch: {
    value: {
      deep: true,
      handler(value) {
        this.localValue = cloneDeep(value)
      }
    }
  }
}
</script>

<style scoped>

.card {
  border-radius: 20px !important;
}

.card-title >>> .v-text-field {
  margin: 0;
  padding: 0;
}

.home-tabs li {
  display: list-item;
  text-align: left;
}

.home-tabs p {
  font-size: 25px;
  margin-bottom: -10px;
}

.tab {
  color: #90a4ae !important;
}

.filter {
  max-width: 50%;
}

.filter >>> .v-input__control {
  max-height: 28px;
}

.filter >>> input[type=text] {
  font-size: 14px;
  padding: 4px 0;
}

.filter >>> .v-label {
  font-size: 14px;
}

.filter >>> .v-icon {
  font-size: 20px;
}

.table {
  overflow-y: auto;
}

.table >>> .v-data-table__wrapper {
  overflow: unset;
}

.table >>> .theme--light.v-progress-linear {
  height: 2px !important;
}

.table >>> th {
  white-space: nowrap;
}

.table >>> .v-data-table-header th {
  color: #37474f !important;
  font-weight: 500 !important
}

.table >>> tbody tr {
  color: #37474f !important;
}

.table >>> tbody tr:hover {
  background-color: #fff !important;
}
.table >>> .eye-btn:hover {
  color: #2196f3 !important
}

.table >>> .edit-btn:hover {
  color: #43A047!important
}

.table >>> .remove-btn:hover {
  color: #ff6666 !important
}

.table >>> .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  /*box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.06), inset 0 1px 4px rgba(0, 0, 0, 0.06) !important; */
  box-shadow: none !important;
}
</style>
